module.exports = __webpack_public_path__ + "static/media/empty.06534d33.png";